import * as React from "react";
import { Children } from "react";
import { isNil } from "ramda";
import { styled } from "styled-components";

import { ValidationError } from "affinityUI/form/components";

import { useAffinityField } from "../../helpers";

import { Option } from "./components/option";

const PickerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

type OptionWithInjectedName = React.FC<Omit<React.ComponentProps<typeof Option>, "name">>;

export const RadioPickerField: React.FC<{ name: string; children: JSX.Element | JSX.Element[] }> & {
  Option: OptionWithInjectedName;
} = ({ children, name }) => {
  const [, { error }] = useAffinityField(name);
  return (
    <PickerContainer id={name}>
      {error && <ValidationError>{error}</ValidationError>}
      {Children.map(children, (child) => {
        const optionComponent = child as JSX.Element;
        if (
          isNil(optionComponent) ||
          ("type" in optionComponent &&
            (typeof optionComponent?.type === "string" || optionComponent?.type?.displayName !== "Option"))
        ) {
          // eslint-disable-next-line no-console
          console.error("RadioPicker accepts only Option components as children");
          return null;
        }
        return React.cloneElement(optionComponent, { name });
      })}
    </PickerContainer>
  );
};
RadioPickerField.Option = Option as OptionWithInjectedName;
